module.exports = __webpack_public_path__ + "static/media/15UN-Habitat1.96eb8f51.jpg";